module.exports = __webpack_public_path__ + "item.eb432582.png";